import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';
import type { SCurveCumulativePoint } from '@/types/analyticsApi';
import { buildScurveSeries } from './chartUtils';

export interface SCurveDurationChartProps {
  planned?: SCurveCumulativePoint[];
  earned?: SCurveCumulativePoint[];
  showBaseline?: boolean;
  baselinePlanned?: SCurveCumulativePoint[];
  baselineEarned?: SCurveCumulativePoint[];
  /** Legend / series labels (default Planned / Earned) */
  plannedLabel?: string;
  earnedLabel?: string;
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function SCurveDurationChart({
  planned,
  earned,
  showBaseline = false,
  baselinePlanned,
  baselineEarned,
  plannedLabel = 'Planned',
  earnedLabel = 'Earned',
  height = 260,
  showDataLabels = false,
  density = 'overview',
}: SCurveDurationChartProps) {
  const { xAxisData, series } = useMemo(() => {
    const built = buildScurveSeries(planned, earned, plannedLabel, earnedLabel);
    if (!showBaseline || !baselinePlanned?.length) return built;
    const baselineBuilt = buildScurveSeries(baselinePlanned, [], 'Baseline', '');
    if (!baselineBuilt.series[0]) return built;
    return {
      xAxisData: built.xAxisData,
      series: [...built.series, { name: 'Baseline', data: baselineBuilt.series[0].data }],
    };
  }, [planned, earned, showBaseline, baselinePlanned, plannedLabel, earnedLabel]);
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
